import { render, staticRenderFns } from "./AdministratorProfile.vue?vue&type=template&id=65abc81b&"
import script from "./AdministratorProfile.vue?vue&type=script&lang=js&"
export * from "./AdministratorProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports